import { render, staticRenderFns } from "./Hamburger.vue?vue&type=template&id=5132fbfc&scoped=true&"
import script from "@/components/SideNavigation/Hamburger/Hamburger.ts?vue&type=script&lang=ts&"
export * from "@/components/SideNavigation/Hamburger/Hamburger.ts?vue&type=script&lang=ts&"
import style0 from "@/components/SideNavigation/Hamburger/Hamburger.scss?vue&type=style&index=0&id=5132fbfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5132fbfc",
  null
  
)

export default component.exports